module.exports = __webpack_public_path__ + "static/media/Sidebar-home-icon-active.b9cdb080.svg";